// extracted by mini-css-extract-plugin
module.exports = {"objectSpec":"CarrierConfiguration_objectSpec__1CEoM","viewSpec":"CarrierConfiguration_viewSpec__3SEkU"};